<template>
	<v-chip
		:small="small"
		:color="color"
		:close="clearable"
		v-on="$listeners"
	>
		<slot></slot>
		<v-icon v-if="icon" :left="!iconRight" :right="iconRight">{{icon}}</v-icon>
	</v-chip>
</template>

<script>
export default {
	props: {
		small: Boolean,
		color: String,
		clearable: Boolean,
		icon: String,
		iconRight: Boolean,
	},
}
</script>
